export const formatNOK = function (amount, suffix = ',-') {
    const strAmount = String(amount).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return `${strAmount}${suffix}`;
};
